<template>
    <div class="" :class="{'show-aside': show_sidebar}">
        <div class="app-wrapper pt-20" v-if="!showBanner">
            <DHeader @childToParent="updateDHeader"/>
        </div>
        <div class="mb-0" v-if="showBanner">
            <div class="bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-bottom landing-dark-bg">

                <DHeader @childToParent="updateDHeader"/>


                <div class="d-flex flex-column flex-center w-100 min-h-250px min-h-lg-300px px-9 app-wrapper">
                    <div class="text-center mb-0 py-5 py-lg-10">
                        <h1 class="text-white lh-base fw-bold fs-2x fs-lg-3x ">{{$t('banner1')}}
                            <br>
                            <span style="color: #FFB400;">
								<span id="kt_landing_hero_text">{{$t('banner2')}}</span>
							</span>
                            <br/>{{$t('banner3')}}
                            <br/>{{$t('banner4')}} <a href="https://admission.umft.ro" >admission.umft.ro</a>

                        </h1>
                    </div>
                </div>
                <div class="landing-curve landing-dark-color mb-10 mb-lg-20">
                    <svg viewBox="15 12 1470 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 11C3.93573 11.3356 7.85984 11.6689 11.7725 12H1488.16C1492.1 11.6689 1496.04 11.3356 1500 11V12H1488.16C913.668 60.3476 586.282 60.6117 11.7725 12H0V11Z" fill="currentColor"></path>
                    </svg>
                </div>

            </div>

        </div>

        <div class="container-xxl mh-100vh">
            <DSidebar @childToParent="updateDHeader"/>

            <div class="content">
                <router-view v-slot="{ Component }">
                    <component :is="Component" />
                </router-view>
            </div>

        </div>

        <DFooter/>
        <ScrollTopArrow/>
    </div>

</template>
<script>
import DHeader from '../views/components/partials/DHeader'
import DFooter from '../views/components/partials/DFooter'
import ScrollTopArrow from '../views/components/partials/ScrollTopArrow'
import DSidebar from '../views/components/partials/DSidebar'

export default {
    name: 'Default',
    components: {
        DHeader,
        DFooter,
        DSidebar,
        ScrollTopArrow
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {

                this.showBanner = ( to.name=='home' || to.name=='Ciclustudiu' );
            }
        }
    },
    mounted () {
        document.body.classList.add('app-front')
    },
    destroyed () {
        document.body.classList.remove('app-front')
    },
    methods: {
        updateDHeader(data) {
            this.show_sidebar = data;

        },
    },
    data () {
        return {
            showBanner: true,
            show_sidebar: false
        }
    }
}
</script>
<style scoped>
.landing-curve {
    background: var(--kt-app-bg-color);
}
</style>
